import React from "react";

function InactivityPage() {
  return (
    <div style={{ margin: "20px" }}>
      Your session has timed out
      <br />
      <a href="/digital-onboarding">Back to Home</a>
    </div>
  );
}

export default InactivityPage;
